var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Checkbox, Input } from "semantic-ui-react";
import Grid from "semantic-ui-react/dist/commonjs/collections/Grid/Grid";
import FieldWithErrorDisplay from "../FieldWithErrorDisplay";
import { Help } from "../Help";
import { formatMonetaryDecimal } from "../kit/rna-fish/EditKitForm";
import { parseMonetaryInput } from "./AddOrderShipmentTracking";
var CustomPriceRow = /** @class */ (function (_super) {
    __extends(CustomPriceRow, _super);
    function CustomPriceRow(props) {
        var _this = _super.call(this, props) || this;
        _this.onCustomPriceChange = function (event, data) {
            var cents = _this.props.defaultEffectivePriceCents ? _this.props.defaultEffectivePriceCents : 0;
            var priceText = _this.props.defaultEffectivePriceCents ? (_this.props.defaultEffectivePriceCents / 100.0).toString() : '';
            var checked = data.checked;
            _this.setState({
                effectivePriceText: priceText,
            }, function () {
                var fn;
                if (checked) {
                    fn = function () { return ({
                        effectivePriceCents: cents,
                        listPriceCents: 0
                    }); };
                }
                else {
                    fn = function () { return undefined; };
                }
                _this.props.onPriceChange(fn, _this.props.onUserInput);
            });
        };
        _this.onEffectivePriceChange = function (event) {
            var str = event.currentTarget.value;
            var cents = parseMonetaryInput(str);
            _this.setState({
                effectivePriceText: str
            }, function () {
                if (cents === undefined) {
                    _this.setState({
                        effectivePriceError: true
                    });
                    return;
                }
                _this.setState({
                    effectivePriceError: false
                }, function () {
                    _this.props.onPriceChange(function (oldPrice) {
                        if (oldPrice === undefined) {
                            return {
                                effectivePriceCents: cents,
                                listPriceCents: 0
                            };
                        }
                        return {
                            effectivePriceCents: cents,
                            listPriceCents: oldPrice.listPriceCents
                        };
                    });
                });
            });
        };
        _this.onListPriceChange = function (event) {
            var str = event.currentTarget.value;
            var cents = parseMonetaryInput(str);
            _this.setState({
                listPriceText: str,
            }, function () {
                if (cents === undefined) {
                    _this.setState({
                        listPriceError: true
                    });
                    return;
                }
                _this.setState({
                    listPriceError: false
                }, function () {
                    _this.props.onPriceChange(function (oldPrice) {
                        if (oldPrice === undefined) {
                            return {
                                effectivePriceCents: 0,
                                listPriceCents: cents
                            };
                        }
                        return {
                            effectivePriceCents: oldPrice.effectivePriceCents,
                            listPriceCents: cents
                        };
                    });
                });
            });
        };
        _this.errors = function () {
            var errors = Array.from(_this.props.errors);
            if (_this.state.effectivePriceError) {
                errors.push({
                    path: _this.props.errorPathPrefix + "/customEffectivePriceCents",
                    msg: 'Invalid number format'
                });
            }
            if (_this.state.listPriceError) {
                errors.push({
                    path: _this.props.errorPathPrefix + "/customListPriceCents",
                    msg: 'Invalid number format'
                });
            }
            return errors;
        };
        _this.state = {
            effectivePriceError: false,
            listPriceError: false,
            effectivePriceText: '',
            listPriceText: ''
        };
        return _this;
    }
    CustomPriceRow.prototype.render = function () {
        var customPriceEnabled = this.props.customPrice !== undefined;
        var customPrice = this.props.customPrice;
        return React.createElement(React.Fragment, null,
            React.createElement(Grid.Row, { verticalAlign: 'top' },
                customPriceEnabled && customPrice &&
                    React.createElement(React.Fragment, null,
                        React.createElement(Grid.Column, { width: 4 },
                            React.createElement(FieldWithErrorDisplay, { errorPath: this.props.errorPathPrefix + "/customListPriceCents", errors: this.errors(), labelContent: 'List price', labelFor: 'list-price' },
                                React.createElement(Input, { name: 'list-price', onBlur: this.props.onUserInput, onChange: this.onListPriceChange, value: this.state.listPriceText })),
                            React.createElement("div", { style: { color: 'grey' } },
                                "\u2937 Parsed as: $",
                                formatMonetaryDecimal(customPrice.listPriceCents))),
                        React.createElement(Grid.Column, { width: 4 },
                            React.createElement(FieldWithErrorDisplay, { errorPath: this.props.errorPathPrefix + "/customEffectivePriceCents", errors: this.errors(), labelContent: 'Effective price', labelFor: 'effective-price' },
                                React.createElement(Input, { name: 'effective-price', onBlur: this.props.onUserInput, onChange: this.onEffectivePriceChange, value: this.state.effectivePriceText })),
                            React.createElement("div", { style: { color: 'grey' } },
                                "\u2937 Parsed as: $",
                                formatMonetaryDecimal(customPrice.effectivePriceCents)))),
                React.createElement(Grid.Column, { width: customPriceEnabled ? 8 : 16 },
                    React.createElement("div", { style: {
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                            gap: '.5rem',
                            flexWrap: 'wrap',
                            minHeight: '100%'
                        } },
                        React.createElement(Checkbox, { checked: customPriceEnabled, disabled: this.props.disabled, label: React.createElement("label", { style: { whiteSpace: 'nowrap' } }, "Custom price"), onChange: this.onCustomPriceChange }),
                        React.createElement(Help, null, "Custom price will take effect for the current kit version only. To avoid mistakenly applying the current custom price to different kit configurations, future edits will need to have their own custom price set.")))));
    };
    return CustomPriceRow;
}(React.PureComponent));
export { CustomPriceRow };
//# sourceMappingURL=CustomPriceRow.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/CustomPriceRow.js
// module id = 41
// module chunks = 0